import {
  error,
  pageInfo,
  VendorItemFragment,
} from 'services/graphql/fragments/Fragments';
import { gql } from 'urql';

const getNearByOffers = gql`
  query GetNearByOffers(
    $categoryId: ID!
    $latitude: Float!
    $longitude: Float!
  ) {
    categoryPage {
      categoryView(
        input: {
          categoryId: $categoryId
          location: { latitude: $latitude, longitude: $longitude }
        }
      ) {
        __typename
        ... on CategoryViewSuccess {
          sections {
            id
            subtitle
            title
            vendors {
              ...VendorItemFragment
            }
          }
          pageInfo {
            ...pageInfo
          }
        }
        ... on CategoryViewError {
          ...error
        }
      }
    }
  }
  ${error}
  ${pageInfo}
  ${VendorItemFragment}
`;

export default getNearByOffers;
